export const home = {
  action: {
    approve_leave: "{name} izin istiyor",
    approve_expense: "{name} masraf bildirdi",
    approve_advance: "{name} avans istiyor",
    document_request: "{type} yükleyin",
    document_request_detail: "İK ekibi istiyor",
    document_required_detail: "Zorunlu belge",
    document_expired_detail: "Süresi doldu; yenisini yükleyin",
    document_rejected_detail: "Önceki yükleme kabul edilmedi",
    fix_returned_leave: "İzin talebiniz düzeltme bekliyor",
    fix_returned_expense: "Masraf formunuz düzeltme bekliyor",
    payslip_new: "{period} bordronuz hazır",
    announcement_ack: "Duyuruyu okuyup onaylayın: {title}",
    asset_ack: "Zimmetinizi teslim aldığınızı onaylayın: {asset}",
    leave_record_ack: "{year} izin kaydınızı kontrol edip onaylayın",
    leave_record_ack_outdated: "Onayladığınız kayıt sonradan değişti; güncel hâlini kontrol edin.",
    task_for: "{employee} için",
  },
  tracked: {
    advance: "Avans",
  },
  status: {
    leave_pending: "Onay bekliyor",
    leave_returned: "Düzeltmeniz gerekiyor",
    leave_approved: "Onaylandı",
    leave_rejected: "Reddedildi",
    expense_draft: "Taslak — henüz gönderilmedi",
    expense_pending: "Onay bekliyor",
    expense_returned: "Düzeltmeniz gerekiyor",
    expense_approved: "Onaylandı — ödeme bekleniyor",
    expense_paid: "Ödendi · {date}",
    expense_rejected: "Reddedildi",
    advance_pending: "Onay bekliyor",
    advance_approved: "Onaylandı — ödeme bekleniyor",
    advance_paid: "Ödendi · {date}",
    advance_rejected: "Reddedildi",
    advance_returned: "Düzeltmeniz gerekiyor",
    finance_pool: "Finans ekibi",
    hr_pool: "İK ekibi",
  },
};
